import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';

if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
  console.error = function () {};
  console.debug = function () {};
  console.warn = function () {};
  console.info = function () {};
  console.trace = function () {};
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <CssBaseline />
    <App />
  </React.StrictMode>
);
